import React from 'react';
import { ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ListGroupItemPatients = ({ data }) => (
  <ListGroupItem
    action
    tag={Link}
    to={`/patients/${data.attributes.patientUid}`}
    className="d-flex justify-content-between align-items-center"

  >
    {data.attributes.lastName}{data.attributes.firstName && `, ${data.attributes.firstName}`}

    <FontAwesomeIcon icon="chevron-right" className="text-muted" />
  </ListGroupItem>
);

ListGroupItemPatients.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
};

export default ListGroupItemPatients;
